import { render, staticRenderFns } from "./msgs.vue?vue&type=template&id=d45e1a64"
import script from "./msgs.vue?vue&type=script&lang=js"
export * from "./msgs.vue?vue&type=script&lang=js"
import style0 from "./msgs.vue?vue&type=style&index=0&id=d45e1a64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports